<template>
  <div v-if="items?.length" class="presets-basic">
    <div v-if="title" class="presets-basic__title-wrap">
      <h3 class="presets-basic__title heading-m">
        {{ title }}
      </h3>
    </div>
    <div
      v-if="items.length < 21 || (mobileFullView && isTablet)"
      class="presets-basic__list"
    >
      <ui-ui-button
        v-for="item in items"
        :key="item.id"
        mode="link"
        font-class="body-m-regular"
        type="secondary"
        size="medium"
        :path="`/${item.slug}/`"
        class="presets-basic__btn"
      >
        {{ item.name }}
      </ui-ui-button>
    </div>
    <ui-horizontal-scroll
      v-else
      ref="presets"
      class="top-presets"
      :style="style"
    >
      <div ref="presetsList" class="top-presets_list">
        <ui-ui-button
          v-for="item in items"
          :key="item.id"
          mode="link"
          font-class="body-m-regular"
          :font-weight="400"
          type="secondary"
          size="medium"
          :path="`/${item.slug}/`"
          class="presets-basic__btn"
        >
          {{ item.name }}
        </ui-ui-button>
      </div>
      <ui-ui-button-ico
        v-if="showMore"
        icon="down"
        class="show-all_btn"
        :class="{ open: isOpened }"
        mode="button"
        size="medium"
        stroke="white"
        size-ico="20"
        @click="onShowMore"
      />
    </ui-horizontal-scroll>
  </div>
</template>

<script setup lang="ts">
import type { AutoFaqBlockItem } from '~/interfaces/api';
import { useShowMore } from '~/composition/useShowMore';
import { useMediaQueryStore } from '~/stores/mediaQuery';

defineProps({
  title: {
    type: String,
  },
  items: {
    type: Array as () => AutoFaqBlockItem[],
    default: () => [],
  },
  mobileFullView: {
    type: Boolean,
    default: false,
  },
});
const presets = ref<{ $el: HTMLElement }>();
const presetsList = ref<HTMLElement>();
const mediaStore = useMediaQueryStore();
const isTablet = computed(() => mediaStore.isTablet);
const { onShowMore, isOpened, showMore, style } = useShowMore(
  presets,
  presetsList,
  4
);
</script>
<style scoped lang="scss" src="./PresetsBasicScss.scss"></style>
